import Vue from 'vue';
import store from 'store';

const redirect_url_key = '_rdrct_rl';
const auth_token_key = '_prly_tk';

// forgot password- sends email to renew password
const forgotPassword = (payload) => Vue.$http.post('/acc/forgot', payload);
// login
const login = (user) => Vue.$http.post('/auth/local', user);
// new password- sets up new password
const newPassword = (payload) => Vue.$http.post('/acc/reset-password', payload);
// sign up
const signup = (payload) => Vue.$http.post('/api/users', payload);
// logout
const logout = () => {
  store.dispatch('logout');
  // Do not remove this setTimeout please. We will address the root problem in the future
  setTimeout(() => {
    Vue.router.push({ name: 'login' });
  }, 200);
};

const decodeQueryParameters = () => {
  return decodeURI(window.location.search)
    .replace('?', '')
    .split('&')
    .map((param) => param.split('='))
    .reduce((values, [key, value]) => {
      values[key] = value;
      return values;
    }, {});
};

const checkAuthClientRedirect = (auth_token) => {
  if (window.location.search) {
    const parameters = decodeQueryParameters();

    const action = parameters['action'];

    const redirect_url = window.location.href.split('&redirectUrl=').pop();

    if (action && redirect_url) {
      const decoded_redirect_url = decodeURIComponent(redirect_url);

      window.localStorage.setItem(redirect_url_key, decoded_redirect_url);

      if (!auth_token) {
        auth_token = window.localStorage.getItem(auth_token_key);
      }

      if (auth_token) {
        if (action === 'login') {
          localStorage.removeItem(redirect_url_key);
          const redirect_symbol = decoded_redirect_url.includes('?')
            ? '&'
            : '?';
          window.location.href = `${decoded_redirect_url}${redirect_symbol}token=${auth_token}`;
        } else if (action === 'logout') {
          store.dispatch('logout');
          localStorage.removeItem(redirect_url_key);

          window.location.href = decoded_redirect_url;
        }

        return true;
      }
    }
  }

  return false;
};

const redirectToAuthClient = (open_on_new_tab = false) => {
  if (!checkAuthClientRedirect()) {
    // The already logged in through Parlay auth flow.
    const persisted_redirect_url = window.localStorage.getItem(
      redirect_url_key
    );

    const has_redirect_url =
      persisted_redirect_url !== 'undefined' && persisted_redirect_url !== null;

    if (has_redirect_url) {
      const auth_token = window.localStorage.getItem(auth_token_key);

      if (auth_token) {
        window.localStorage.removeItem(redirect_url_key);

        const redirect_symbol = persisted_redirect_url.includes('?')
          ? '&'
          : '?';

        const url_to_navigate = `${persisted_redirect_url}${redirect_symbol}token=${auth_token}`;

        if (open_on_new_tab) {
          window.open(url_to_navigate);
        } else {
          window.location.href = url_to_navigate;
        }

        return true;
      }
    }

    return false;
  }

  return true;
};

const setRedirectUrl = (redirect_url) => {
  window.localStorage.setItem(redirect_url_key, redirect_url);
};

const navigateToExternalWithAuth = (redirect_url) => {
  setRedirectUrl(redirect_url);
  redirectToAuthClient(true);
};

export default {
  signup,
  login,
  logout,
  forgotPassword,
  newPassword,
  redirectToAuthClient,
  navigateToExternalWithAuth,
};



// WEBPACK FOOTER //
// ./src/app/features/authentication/authentication.services.js